import { useTranslate } from "src/i18n";
import { pluralNumber } from "src/util/pluralNumber";

import { PluralForms } from "../../../../../utils";

export const useProductPriceSummaryTranslate = () => {
  const { t } = useTranslate();

  const offerForms: PluralForms = [
    t("product_offers.count_one", "предложение"),
    t("product_offers.count_few", "предложения"),
    t("product_offers.count_many", "предложений"),
  ];

  const storeForms: PluralForms = [
    t("product_store.count_one", "площадке"),
    t("product_store.count_few", "площадках"),
    t("product_store.count_many", "площадках"),
  ];

  return {
    from_price: (price: number, currency: string) =>
      t("product_price.from", "от {price} {currency}", { price, currency }),
    offers_on_stores: (offersCount: number, storesCount: number) =>
      `${offersCount} ${pluralNumber(offersCount, offerForms)} на ${storesCount} ${pluralNumber(storesCount, storeForms)}`,
  };
};
